import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { Search, Close } from "@mui/icons-material";
import _ from "lodash";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import { Loader } from "src/components/loader";
import { getAllClientProject, unlistClient } from "src/thunks/clientProjects";
import { ClientDetailView } from "./components/detailView";
import { AddClientForm } from "./components/addClientForm";
import { CommonModal } from "src/components/modal";
import toastMessages from "src/constant/toastMessages.json";
import { GetError } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";

const ClientsProjectsTab = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const StateData = useSelector((state) => state?.clientProjects);

  /** hooks useState ----------------------------------------------------- **/
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [clientProjectShowData, setClientProjectShowData] = useState([]);
  const [showViewRecordButton, setShowViewRecordButton] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [isEditFlag, setIsEditFlag] = useState(false);
  const [isEditTextShown, setIsEditTextShown] = useState(false);
  const [mounted, setMounted] = useState(true);

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    if (mounted) {
      setClientProjectShowData([...(StateData?.clientProject || [])]);
    }
  }, [StateData]);

  useEffect(() => {
    getAllClientsData();
    return () => setMounted(false);
  }, []);

  /** handler functions--------------------------------------------------- **/
  const handleOpen = () => {
    setIsEditTextShown(false);
    setOpen(!open);
  };

  const handleRowClick = (item) => {
    setSelectedRow(item);
    setShowViewRecordButton(!showViewRecordButton);
  };

  const handleViewRecordButtonClick = async () => {
    setIsEditFlag(true);
  };

  /**  Function to navigate back. ---------------------------- **/
  const handleBackButtonClick = () => {
    setIsEditFlag(false);
    setSelectedRow({});
  };

  /** Function executes when the user searches for clients by name. ----------------------- **/
  const handleSearchInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
    if (searchText === "") {
      setClientProjectShowData(StateData?.clientProject);
    } else {
      const newFilter = StateData?.clientProject.filter((value) => {
        return value.name.toLowerCase().includes(searchText.toLowerCase());
      });
      setClientProjectShowData(newFilter);
    }
  };

  /** Function to clear search text value ------------------------ **/
  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  /** Function to retrieve all client data with projects. --------------------- **/
  const getAllClientsData = async () => {
    setLoader(true);
    try {
      await dispatch(getAllClientProject()).unwrap();
      setLoader(false);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
      setLoader(false);
    }
  };

  /** Function that executes when a client is unlisted ----------------- **/
  const handleUnlistClients = async (id) => {
    try {
      let result = await dispatch(
        unlistClient({ id: id, ...selectedRow })
      ).unwrap();
      setTimeout(() => {
        dispatch(getAllNofificationForDashboard(1, 20));
      }, 2000);
      getAllClientsData();
      setIsEditFlag(false);
      toast.success(toastMessages.clientUnlisted);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  if (loader) {
    return <Loader />;
  }
  return (
    <>
      {!isEditFlag ? (
        <>
          <div className="row flex-row top-section-depots-personal-tab justify-content-between align-items-center mt-3">
            <div className="col-md-3" style={{ position: "relative" }}>
              <input
                style={{ position: "relative", width: "100%" }}
                className="search-input-for-depot-personal-tab"
                type="text"
                placeholder="Search by client..."
                value={searchValue}
                onChange={handleSearchInputChange}
              />
              {searchValue !== "" ? (
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={handleClearSearchText}
                  className="search-icon-depotpersonal-style"
                />
              ) : (
                <Search className="search-icon-depotpersonal-style" />
              )}
            </div>
            <div className="col-md-9 "></div>
          </div>
          <div
            className={`table-responsive ${clientProjectShowData?.length < 10
                ? ""
                : "main-div-admin-depotpersonal-tab"
              } d-flex flex-column mt-2`}
          >
            <table
              className="table admintab-depots-personal-table table-borderless"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th scope="col" style={{ minWidth: "200px" }}>
                    CLIENT
                  </th>
                  <th scope="col" style={{ minWidth: "200px" }}>
                    CONTACT PERSON
                  </th>
                  <th scope="col" style={{ minWidth: "200px" }}>
                    EMAIL
                  </th>
                  <th scope="col" style={{ minWidth: "102px" }}>
                    PHONE
                  </th>
                  <th scope="col" style={{ minWidth: "80px" }}>
                    PROJECT
                  </th>
                  <th scope="col" style={{ minWidth: "100px" }}>
                    PROJECT MANAGERS
                  </th>
                </tr>
              </thead>
              <tbody className="depotsperosnal-admin-tbl-body">
                {clientProjectShowData && clientProjectShowData?.length > 0 ? (
                  _.orderBy(
                    clientProjectShowData,
                    (d) => d.name.toLowerCase(),
                    ["asc"]
                  ).map((item, index) => {
                    let managersCount = _.sum(
                      _.map(item.projects || [], (d) => d.users.length)
                    );
                    return (
                      <React.Fragment key={index}>
                        <tr
                          onClick={() => handleRowClick(item)}
                          className={`${selectedRow.id == item.id ? "row-border" : ""
                            }`}
                        >
                          <td>{item.name} </td>
                          <td>{item.contactPerson}</td>
                          <td>{item.email}</td>
                          <td>{item.phoneNumber}</td>
                          <td>{item.projects.length}</td>
                          <td>{managersCount}</td>
                        </tr>
                        {showViewRecordButton && selectedRow.id == item.id && (
                          <tr className={`view-record-button`}>
                            <td>
                              <button
                                type="button"
                                className="text-uppercase view-button"
                                onClick={handleViewRecordButtonClick}
                              >
                                <i className="bi bi-eye-fill view-record-icon"></i>{" "}
                                View Record
                              </button>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      className="not-found-txt"
                      colSpan="8"
                      style={{ textAlign: "center" }}
                    >
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            style={{ height: 60, marginRight: 20 }}
            className="d-flex flex-row justify-content-end align-items-center"
          >
            <Button
              variant="outlined"
              className="btn-bootstrap-submit-style"
              startIcon={
                <img src={IconNewRecord} width={17} height={17} alt="new"></img>
              }
              type="submit"
              onClick={handleOpen}
            >
              Add Client
            </Button>
          </div>
        </>
      ) : (
        <ClientDetailView
          setOpen={handleOpen}
          setIsEditTextShown={setIsEditTextShown}
          isEditTextShown={isEditTextShown}
          handleBackButtonClick={handleBackButtonClick}
          handleViewRecordButtonClick={handleViewRecordButtonClick}
          selectedRow={selectedRow}
          handleUnlistClients={handleUnlistClients}
        />
      )}
      <CommonModal togal={open} toggleHandler={handleOpen}>
        <AddClientForm
          setIsEditTextShown={setIsEditTextShown}
          isEditTextShown={isEditTextShown}
          setOpen={handleOpen}
          fetchData={() => getAllClientsData()}
          editData={{}}
        />
      </CommonModal>
    </>
  );
};

export default ClientsProjectsTab;
